import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  mapModifires,
  mergeModifires,
  type typeModifires,
} from "@/components/utils/modifires";
import { withDefaults } from "vue";

interface Props {
  modifires?: typeModifires;
  column?: string;
  align?: "left" | "center" | "right";
  vertical?: "top" | "center" | "bottom";
}

export default /*#__PURE__*/_defineComponent({
  __name: 'form-unit-row',
  props: {
    modifires: { type: [String, Array, Boolean] },
    column: {},
    align: {},
    vertical: {}
  },
  setup(__props: any) {

const props = __props;



const componentClass = () =>
  mapModifires(
    "form-unit-row",
    mergeModifires(
      props.modifires,
      props.align && `align-${props.align}`,
      props.vertical && `vertical-${props.vertical}`
    )
  );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(componentClass())
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})